module.exports = __webpack_public_path__ + "img/4@2x.82a0777.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/4@2x.png
// module id = 96S/
// module chunks = 0